import { Vue, Prop, Component } from 'vue-property-decorator';
import TextField from '../inputs/TextField.vue';

@Component
export class InputPages extends Vue {
  public title = '';

  public error_summary: string[] = [];

  @Prop({ default: false })
  public forDisplay!: boolean;

  public errors: string[] = [];

  // updated() {
  //   this.error_summary = [];
  // }

  validate() {
    console.log('default valid');
    // this.error_summary = [];
    // for (const refName in this.$refs) {
    //   const ref = this.$refs[refName];
    //   if (ref instanceof TextField) {
    //     const text = ref as any;
    //     this.error_summary.push(text.error);
    //   }
    // }
    // if (this.error_summary.length > 0) {
    //   this.error_summary = this.error_summary.filter((i) => i);
    //   return false;
    // }
    return true;
  }
}
